/*
 * @Author: weiShu
 * @Date: 2025-12-29 15:40:44
 * @LastEditors: weiShu
 * @LastEditTime: 2026-04-24 09:29:26
 * @FilePath: \health-commission-new-2\src\utils\server.js
 * @Description: 
 */
/**
 * http配置
 */
import Vue from 'vue'
import axios from 'axios'
import router from '@/router/index.js'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { triggerWxLoginByRedirect } from '@/utils/wx-auth'

import { Toast } from 'vant';
Vue.use(Toast);


// document.cookie = 'is_debug_user=true'
axios.defaults.withCredentials = true
var httpConfig = {
  baseURL: process.env.NODE_ENV == 'development' ? '/api/api' : process.env.VUE_APP_API_URL+'/api',  //正式地址
  timeout: 20000,
  withCredentials: true, // 允许携带cookie
  // cookie: 'is_debug_user=true',
}
//console.log(httpConfig)
//基地址
const instance = axios.create(httpConfig)

//请求拦截器
instance.interceptors.request.use(
  config => {
    //  console.log(config)
    if (config.formData) {
      let formData = new FormData();
      for (var key in config.formData) {
        formData.append(key, config.formData[key])
      }
      //console.log(formData)
      config.data = formData;
    }
    //请求拦截给请求头里放个token
    //console.log('请求拦截给请求头里放个token',getToken());  
    if (getToken()) {
      config.headers.Authorization = getToken();
      config.headers['token'] = getToken();
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }

)

//响应拦截器
instance.interceptors.response.use(
  response => {
    //重置Token
    var token = response.headers['token']
    if (token != undefined) {
      setToken(token)
    }
    //alert(cookie)
    //console.log(cookie)
    const res = response.data;
    //console.log(res);
    if (res.code == 200) {
      return res
    } else if (res.code == -1001) {
      // token 失效：清理本地 token，并触发微信授权登录
      removeToken()
      Toast(res.msg ? res.msg : '登录已失效，请重新授权')
      triggerWxLoginByRedirect().catch(() => {})
      return Promise.reject(res)
    }else {
      if (!response.config.silentToast) {
        Toast(res.msg ? res.msg : '系统繁忙');
      }
      return Promise.reject(res)
    }
  },
  error => {
    console.log('error' + error) // for debug

    return Promise.reject(error)
  }
)
export default instance